import React, { useEffect, useState } from "react";
import CommentListingComponent from "./CommentListingComponent";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";

import {
  ManageComments,
  showMessage,
  getToken,
  ManageProducts,
  ManageRestaurant,
  ManageCustomer,
} from "../../Functionalities/Functions";
import { protocol, token, url } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import TemplateComponent from "../../CoreComponents/DataList/DataList";
import NoDataComponent from "../../CoreComponents/NoDataComponent";

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true)
  const [products, setProducts] = useState([])
  const [restaurants, setRestaurants] = useState([])
  const [users, setUsers] = useState([])
  const [search_text, setSearchText] = useState({
    product: ' ',
    reviewer: '',
    restaurant: '',
  })
  const [selected, setSelected] = useState({
    product: '',
    reviewer: '',
    restaurant: '',
  })
  const [filter, setFilter] = useState({
    reviewer_id: '',
    product_id: '',
    restaurent_id: '',
    search_text: ''
  })

  useEffect(() => {
    // alert('ok')
    getData();
  }, [filter.product_id, filter.restaurent_id, filter.reviewer_id,]);

  
  const filterChange = (label, val, item) => {
    if(label == 'Product'){
      setFilter({...filter, product_id: val})
      setSelected({...selected, product: item})
    }
    if(label == 'Restaurant'){
      setFilter({...filter, restaurent_id: val})
      setSelected({...selected, restaurant: item})

    }
    if(label == 'Reviewer'){
      setFilter({...filter, reviewer_id: val})
      setSelected({...selected, reviewer: item})
    }
    
  }

  const handleClearFilter = (label) =>{
    if(label == 'Product'){
      setFilter({...filter, product_id: ''})
      setSelected({...selected, product: ''})
      setSearchText({
        ...search_text,
        product: '',
      })
    }
    if(label == 'Restaurant'){
      setFilter({...filter, restaurent_id: ''})
      setSelected({...selected, restaurant: ''})
      setSearchText({
        ...search_text,
        reviewer: '',
      })

    }
    if(label == 'Reviewer'){
      setFilter({...filter, reviewer_id: ''})
      setSelected({...selected, reviewer: ''})
      setSearchText({
        ...search_text,
        restaurant: '',
      })
    }
  }
  const searchTextChange = (label, val) => {
    if(label == 'Product'){
      setSearchText({...search_text, product: val})
    }
    if(label == 'Restaurant'){
      setSearchText({...search_text, restaurant: val})
    }
    if(label == 'Reviewer'){
      setSearchText({...search_text, reviewer: val})
    }
  }

  const getData = () => {
    // void 0

    // showMessage("Loading reviews", "info", "Loading", "bottom", "bottom-left", 0);
    let params = ''
    if(filter.reviewer_id){
      if(params){
        params = params + '&reviewer_id=' +filter.reviewer_id
      }else{
        params = 'reviewer_id=' + filter.reviewer_id
      }
    }
    if(filter.product_id){
      if(params){
        params = params + '&product_id=' +filter.product_id
      }else{
        params = 'product_id=' + filter.product_id
      }
    }
    if(filter.restaurent_id){
      if(params){
        params = params + '&restaurent_id=' +filter.restaurent_id
      }else{
        params = 'restaurent_id=' + filter.restaurent_id
      }
    }
    if(filter.search_text){
      if(params){
        params = params + '&search_text=' +filter.search_text
      }else{
        params = 'search_text=' + filter.search_text
      }
    }

    let result = ManageComments("", "", "get", params);
    result
      .then((result) => {
        setData({
          ...data,
          data: result.data.results || result.data || [],
        });
        setLoading(false)
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      // url: prev,
      url: prev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results || response.data || [],
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace('//', "")),
      // url: next,
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results || response.data || [],
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const fetchProduct = () => {
    // alert('working')
    let params = "for_dropdown=true&my_branch=true&order_by_name=true&blocked_out_drop_down=true"
    if(search_text.product){
      params = params + '&search_text=' + search_text.product
    }
    if(filter.restaurent_id){
      params = params + '&branch_id=' + filter.restaurent_id
    }

    let result = ManageProducts("", "", "get", params);
    result.then((result) => {
      setProducts(result.data.results || result.data || [])
    }).catch(err=> {
    })
  };

  const fetchBranches = () => {
    let params = "for_dropdown=true&order_by_name=true";
    if(search_text.restaurant){
      params = params + '&search_text=' + search_text.restaurant
    }
    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setRestaurants(result?.data?.results || result?.data || [])
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  const fetchUsers = () => {
    // alert('working')
    let params = "my_branch=true&order_by_name=true&blocked_out_drop_down=true&for_admin_panel_listing=true&keyword=all_profile"
    if(search_text.reviewer){
      params = params + '&search_text=' + search_text.reviewer
    }

    let result = ManageCustomer("", "", "get", params);

    result.then((result) => {
        setUsers(result.data.results || result.data || [])
      }).catch((err) => {
        showMessage("Loading failed","danger","Loading error","top","top-right",0);
        // void 0
      });
  };

  useEffect(() => {
     fetchProduct()
  }, [search_text.product, search_text.restaurant])

  useEffect(() => {
      fetchBranches()
  }, [search_text.restaurant])

  useEffect(() => {
    fetchUsers()
  }, [search_text.reviewer])

  return (
    <div className="content-body">
      {!loading ?
       
        <div className="container-fluid">
          <FilterComponent
            handleNext={handleNext}
            handlePrev={handlePrev}
            next={next}
            prev={prev}
            filterButtonName={"Filter"}
          />
           <FilterModalComponent
            moreWidth={true}
            heading={"Filter Reviews"}
            // searchItemValue={filter.search_text}
            searchItemChange={(e) =>
            
             {}
            }
            clearFilter={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
            submitFilter={(e) => {
              e.preventDefault();
              getData();
            }}
            page="comments"
          >
             <div className="col-lg-12 mb-3">
                <input placeholder="Search by review text" className="form-control" value={filter.search_text} onChange={e=> setFilter({...filter, search_text: e.target.value})}/>
              </div>
            <div className="d-flex" style={{marginBottom: 300}}>
              <div className="col-lg-4">
                  <div className="form-group">
                    <TemplateComponent label="Restaurant" value={search_text.restaurant} searchTextChange={searchTextChange} data={restaurants} filterChange={filterChange}/>
                  </div>
                  {selected.restaurant && <label className="text-black">
                    {selected.restaurant.id} - {selected.restaurant && (selected.restaurant.name.length > 20 ? (selected.restaurant.name.slice(0, 20) + '...') : selected.restaurant.name)}
                    <span className="ml-2"><i onClick={()=>handleClearFilter('Restaurant')} className="text-color-primary fs-20 fa fa-times-circle cursor-pointer"/></span>
                  </label>}
              </div>
              <div className="col-lg-4">
                  <div className="form-group">
                    <TemplateComponent label="Product" value={search_text.product} searchTextChange={searchTextChange} data={products} filterChange={filterChange}/>
                  </div>
                  {selected.product && <label className="text-black">
                  {selected.product.id} - {selected.product && (selected.product.name.length > 20 ? (selected.product.name.slice(0, 20) + '...') : selected.product.name)}
                    <span className="ml-2"><i onClick={()=>handleClearFilter('Product')} className="text-color-primary fs-20 fa fa-times-circle cursor-pointer"/></span>
                  </label>}
              </div>
              <div className="col-lg-4">
                  <div className="form-group">
                    <TemplateComponent label="Reviewer" value={search_text.reviewer} searchTextChange={searchTextChange} data={users} filterChange={filterChange}/>
                  </div>
                {selected.reviewer && <label className="text-black">{selected.reviewer.id} - {selected.reviewer && (selected.reviewer.first_name.length > 20 ? (selected.reviewer.first_name.slice(0, 20) + '...') : selected.reviewer.first_name)}
                    <span className="ml-2"><i onClick={()=>handleClearFilter('Reviewer')} className="text-color-primary fs-20 fa fa-times-circle cursor-pointer"/></span>
                  </label>}
                </div>
            </div>

          </FilterModalComponent>

          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="row">
                <div className="col-xl-12">
                  <div className="tab-content">
                    <div className="tab-pane fade show active" id="All">
                      { data.data.length > 0?
                       <div className="card">
                        <div>
                          <div className="card-body p-0">
                            {data.data.map((item, index) => {
                              return <CommentListingComponent review={item} />;
                            })}
                          </div>
                        </div>
                      </div>
                      :
                      <NoDataComponent data="comments by the customers" />  
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        : <LoadingComponent />
      }
    </div>
  );
}

function Comments() {
  const header = "";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Review"} subHeading={"All review under foodoor"} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Comments;
